// Display.tsx
import React, { useState } from 'react';
import './Display.scss';
import { DetailDataItem } from '../../Analytics2/types/types';

interface DisplayProps {
  visual: DetailDataItem;
}

const Display: React.FC<DisplayProps> = ({ visual }) => {
  const [showThumbnail, setShowThumbnail] = useState(false);
  const isVideo = visual.visual_type?.toLowerCase() === 'video';
  const hasThumbnail = isVideo && visual.thumbnail_url;

  const renderAsset = () => {
    if (!visual.s3_url) {
      return (
        <p className="missing-asset-url">
          <i className="fa-solid fa-triangle-exclamation"></i>
          Missing asset URL
        </p>
      );
    }

    if (visual.visual_type?.toLowerCase() === 'image') {
      return <img className="report-card__img" src={visual.s3_url} alt={visual.ad_name} />;
    }

    if (isVideo) {
      if (showThumbnail && visual.thumbnail_url) {
        return <img className="report-card__img" src={visual.thumbnail_url} alt={visual.ad_name} />;
      }
      
      return (
        <video
          key={visual.s3_url}
          autoPlay
          loop
          muted
          playsInline
          className="report-card__img"
          controls
        >
          <source src={visual.s3_url} type="video/mp4" />
        </video>
      );
    }

    return null;
  };

  return (
    <>
      <div className="report-card__display card">
        <div className="img-background h-100">{renderAsset()}</div>
      </div>
      
      {hasThumbnail && (
        <div className="display-buttons">
          <button
            className={`darwin-button ${showThumbnail ? '' : 'darwin-button--inactive'}`}
            onClick={() => setShowThumbnail(true)}
          >
            Thumbnail
          </button>
          <button
            className={`darwin-button ${!showThumbnail ? '' : 'darwin-button--inactive'}`}
            onClick={() => setShowThumbnail(false)}
          >
            Full Video
          </button>
        </div>
      )}
    </>
  );
};

export default Display;